import { render, staticRenderFns } from "./CustodianBankIndexPage.vue?vue&type=template&id=29a18484&"
import script from "./CustodianBankIndexPage.vue?vue&type=script&lang=js&"
export * from "./CustodianBankIndexPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports